import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setBreadcrumb } from 'components/Navbar/modules';
import { resetAll } from 'modules/steps/actions';
import Connections from '../components';

function mapStateToProps(state) {
  return {
    app: state.app,
    literals: state.i18n.literals.callforImpactHall || {},
    calls: state.narratives.list,
    chats: state.chats.chats,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Connections));



// WEBPACK FOOTER //
// ./src/routes/CallForImpactHall/container/index.js